import { format } from "date-fns";
import { useEffect, useState } from "react";
import butter from "../../../utils/butter-client";
import Open from "../../assets/icons/Open.svg";
import Image from "next/image";
export const Highlights = () => {
  const [highlights, setHighlights] = useState([]);

  useEffect(() => {
    butter.post.list({ page: 1, page_size: 3 }).then(response => {
      const { data } = response.data;
      setHighlights(data);
    });
  }, []);

  return (
    <section className="home_highlights-background">
      <div className="home_highlights">
        <section className="section-layout">
          <h2>Recent highlights from our blog</h2>
          <div className="home_highlights-grid">
            {highlights.map(({ featured_image, title, summary, author, published, slug }) => (
              <a key={title} href={`/blog/${slug}`}>
                <article>
                  <div className="img-container">
                    <Image src={featured_image} alt="" layout="fill" unoptimized />
                  </div>
                  <div className="home_highlights-card_text">
                    <h3>{title}</h3>
                    <img
                      className="open-icon"
                      src={Open.src}
                      alt="Open"
                      loading="eager"
                      width="10"
                      height="10"
                    />
                    <p>{summary}</p>
                  </div>
                  <div className="author">
                    <img
                      className="avatar"
                      src={author.profile_image}
                      alt=""
                      title={`${author.first_name} ${author.last_name}`}
                      loading="lazy"
                      width="40"
                      height="40"
                    />
                    <div>
                      <p>
                        {author.first_name} {author.last_name}
                      </p>
                      <span>{format(new Date(published), "LLLL dd, yyyy")}</span>
                    </div>
                  </div>
                </article>
              </a>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
};
